import { createStore, combineReducers } from 'redux'
import state from './reducers/accordionState'

const reducer = combineReducers({
    state
})

const store = createStore(reducer)

export default store